<template>
	<div
		v-bind:class="['chat-received-attachment']"
	>
		<lightbox :options="{rel: 'lightbox[right]'}" :images="[{ src: attachment.attachment.url, thumb: attachment.attachment.thumburl, rel: 'lightbox[right]' }]" :id="index.toString()"></lightbox>
	</div>
</template>

<script>
import Event from '../event.js';
import Lightbox from 'vue-simple-lightbox';
export default {
	props: ["attachment", "index", "Laravel"],
	components: {
		Lightbox,
	}
};
</script>